import React, { FC } from 'react';
import { OfflineOrderPageSkeleton } from '../offlineOrder/offlineOrderSkeleton';

export const TestPageSkeleton: FC = () => <OfflineOrderPageSkeleton />;
